import { useSelector } from 'react-redux'

import Tooltip from '@/components/Tooltip'
import tooltipIcon from '@/images/tooltip_icon_white.svg'
import {
  salesRightsWarningTextSelector,
  salesRightsWarningToolTipTextSelector
} from '@/selectors'

import Icon from '../Tooltip/Icon'

const CurrentRegionOnlySalesRightsWarning = () => {
  const toolTipText = useSelector(salesRightsWarningToolTipTextSelector)
  const text = useSelector(salesRightsWarningTextSelector)

  return (
    <div className='current-region-only-warning'>
      <span className='vst-heading u-push-quarter--right'>
        {text}
      </span>
      <Tooltip tooltipText={toolTipText}>
        <Icon icon={tooltipIcon} />
      </Tooltip>
    </div>
  )
}

export default CurrentRegionOnlySalesRightsWarning
